<script setup lang="ts">
import { router, usePage } from '@inertiajs/vue3'
import { onUnmounted, ref, watch } from 'vue'
import FlashAlerts from '@/components/FlashAlerts.vue'
import NavigationMenu from '@/components/NavigationMenu.vue'

const page = usePage()
const drawer = ref(false)
const navButton = ref()

function logout() {
  router.delete('/logout')
}

// When the menu closes, focus goes back to its button unless the user already moved it elsewhere.
watch(drawer, (open) => {
  if (open) return
  const active = document.activeElement
  if (active === document.body || active?.closest('#app-navigation')) navButton.value?.$el.focus()
}, { flush: 'post' })

// The layout persists across visits, so any navigation (including "back") closes the menu.
const stopListening = router.on('navigate', () => {
  drawer.value = false
})
onUnmounted(stopListening)
</script>

<template>
  <v-app>
    <v-app-bar color="primary" density="comfortable">
      <v-app-bar-nav-icon
        ref="navButton"
        class="nav-toggle"
        aria-label="Abrir menú"
        aria-controls="app-navigation"
        :aria-expanded="drawer"
        @click="drawer = !drawer"
      />
      <v-app-bar-title>Quote App</v-app-bar-title>

      <span class="current-user mr-4">{{ page.props.current_user?.name }}</span>
      <v-btn class="logout" prepend-icon="mdi-logout" @click="logout">Cerrar sesión</v-btn>
    </v-app-bar>

    <NavigationMenu v-model="drawer" />

    <v-main>
      <v-container v-if="page.flash.notice || page.flash.alert" class="pb-0">
        <FlashAlerts />
      </v-container>
      <slot />
    </v-main>
  </v-app>
</template>
